export const games = [
  {
    id: 'busjam',
    title: 'Crazy Bus Jam',
    tagline: 'Traffic Sort Puzzle',
    description:
      'Untangle chaotic bus stops, route every passenger to the right ride, and clear the jam in this addictive sort puzzle.',
    category: 'Puzzle',
    rating: 4.7,
    downloads: '500K+',
    accent: 'linear-gradient(135deg, #ff7a3d 0%, #ff3d7f 100%)',
    image: '/games/busjam.png',
    url: 'https://play.google.com/store/apps/details?id=com.zi.crazy.busjam.traffic.sort.puzzle',
  },
  {
    id: 'cashier',
    title: 'Cashier Craze',
    tagline: 'Casino Simulator',
    description:
      'Run the floor, manage the rush, and grow your tiny corner casino into a glittering empire of chips and lights.',
    category: 'Simulator',
    rating: 4.6,
    downloads: '1M+',
    accent: 'linear-gradient(135deg, #7c5cff 0%, #3dd6ff 100%)',
    image: '/games/cashier.png',
    url: 'https://play.google.com/store/apps/details?id=com.zi.cashier.simulator.business.tycoon',
  },
  {
    id: 'arcade',
    title: 'Arcade Shop',
    tagline: 'Supermarket Simulator',
    description:
      'Stock the shelves, design your aisles, and serve a never-ending stream of shoppers in a vibrant arcade simulator.',
    category: 'Arcade',
    rating: 4.8,
    downloads: '750K+',
    accent: 'linear-gradient(135deg, #3dd6ff 0%, #7c5cff 50%, #ff3d7f 100%)',
    image: '/games/arcade.png',
    url: 'https://play.google.com/store/apps/details?id=com.zi.arcade.shop.supermarket.simulator',
  },
];
